import { Component, OnInit } from '@angular/core';
import { IsActiveMatchOptions, NavigationEnd, Router, RouterModule } from '@angular/router';
import { Store } from '@ngxs/store';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { SidenavService } from '../../../shared/services/sidenav.service';
import { CommonModule } from '@angular/common';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatCommonModule } from '@angular/material/core';
import { ReactiveFormsModule } from '@angular/forms';

interface MenuItem {
    label: string;
    hidden?: boolean;
    routerLink: any[];
    icon: string;
    isDivider?: boolean;
    routerLinkActiveOptions?: { exact: boolean } | IsActiveMatchOptions;
    isActive: boolean;
    panelOpenState?: boolean;
    subItems: MenuItem[];
}

@UntilDestroy()
@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        MatAccordion,
        MatExpansionModule,
        MatCommonModule,
    ],
    providers: [],
})
export class SidenavComponent implements OnInit {
    public topMenuItems: MenuItem[] = [];
    public bottomMenuItems: MenuItem[] = [];

    constructor(
        private readonly store: Store,
        private router: Router,
        private sidenavService: SidenavService,
    ) {}

    ngOnInit(): void {
        this.router.events.pipe(untilDestroyed(this)).subscribe((event: any) => {
            if (event?.routerEvent instanceof NavigationEnd) {
                this._updatePanelState(event.routerEvent.urlAfterRedirects);
            }
        });

        this.sidenavService.topMenuItems$
            .pipe(untilDestroyed(this))
            .subscribe((topMenuItems: MenuItem[]) => {
                if (topMenuItems) {
                    this.topMenuItems = topMenuItems;
                    this._updatePanelState(this.router.url);
                }
            });
        this.sidenavService.bottomMenuItems$
            .pipe(untilDestroyed(this))
            .subscribe((bottomMenuItems: MenuItem[]) => {
                if (bottomMenuItems) {
                    this.bottomMenuItems = bottomMenuItems;
                    this._updatePanelState(this.router.url);
                }
            });

        const currentUrl = this.router.url;
        this._updatePanelState(currentUrl);
    }

    private _updatePanelState(currentUrl: string): void {
        this.topMenuItems.forEach((menuItem) => {
            const subItemsRouterLinks = [
                menuItem.routerLink[0],
                ...menuItem.subItems.map((item) => item.routerLink[0]),
            ];
            menuItem.panelOpenState = subItemsRouterLinks.includes(currentUrl);
            menuItem.isActive = subItemsRouterLinks.includes(currentUrl);
        });

        this.bottomMenuItems.forEach((menuItem) => {
            const subItemsRouterLinks = menuItem.subItems.map((item) => item.routerLink[0]);
            menuItem.panelOpenState = subItemsRouterLinks.includes(currentUrl);
            menuItem.isActive = subItemsRouterLinks.includes(currentUrl);
        });
    }

    public handleClickOnItem() {
        this.sidenavService.toggle();
    }
}
